import {
  Map,
  MapControl,
  MapControls,
  MapGeolocationCustomControl,
  MapZoomCustomControl,
  Route,
} from '@yandex-delivery/blocks'
import {memo} from 'react'

import {i18n} from 'src/shared/config'

import {MapPlacemarks} from '../MapPlacemarks/MapPlacemarks'
import {useFormMap} from './hooks'
import {type Props} from './types'
import {shouldInitializeLocation} from './utils'

export const FormMapUI = memo<Props>(function FormMapUI(props) {
  const {sourcePointCoordinates} = props

  const {
    mapLocation,
    mapMargin,
    controlsPosition,
    lang,
    routePointCoordinates,
    geolocationClickHandler,
    isRouteVisible,
    location,
    orderPointsCoordinates,
    isDragPointAllowed,
    updateMapLocation,
    onPlacemarkChange,
    isOnlySourcePoint,
  } = useFormMap(props)

  return (
    <Map
      errorMessage={i18n('map_load_error', 'Не удалось загрузить карту')}
      lang={lang}
      location={mapLocation}
      margin={mapMargin}
    >
      {isRouteVisible && <Route onBoundsChange={updateMapLocation} points={routePointCoordinates} />}
      <MapControls position={controlsPosition}>
        <MapControl>
          <MapZoomCustomControl setLocation={updateMapLocation} />
        </MapControl>
        <MapControl>
          <MapGeolocationCustomControl
            initializeLocation={shouldInitializeLocation(isRouteVisible, isOnlySourcePoint, sourcePointCoordinates)}
            initialLocation={location}
            onGeolocatePosition={geolocationClickHandler}
            translations={{geolocationError: i18n('geolocation_not_available', 'Нет доступа\nк геолокации')}}
          />
        </MapControl>
      </MapControls>
      <MapPlacemarks
        allPoints={orderPointsCoordinates}
        isDragPointAllowed={isDragPointAllowed}
        onChange={onPlacemarkChange}
        onLocationRequest={updateMapLocation}
        route={routePointCoordinates}
      />
    </Map>
  )
})
